import { importRegistry } from "../import-registry";
import { FaXTwitter, FaCirclePlay } from "react-icons/fa6";

const reactIconsFa = "react-icons/fa6";
importRegistry.registerImports([
  [FaXTwitter, "FaXTwitter", "named", reactIconsFa],
  [FaCirclePlay, "FaCirclePlay", "named", reactIconsFa],
]);
